import { render, staticRenderFns } from "./medicalservices.vue?vue&type=template&id=36f6108d&"
import script from "./medicalservices.vue?vue&type=script&lang=js&"
export * from "./medicalservices.vue?vue&type=script&lang=js&"
import style0 from "./medicalservices.vue?vue&type=style&index=0&id=36f6108d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports